<template>
    <section>
        <List :title="table.title" :breadcumb="table.breadcumb" :dataTable="table.dataTable">
            <template v-slot:button>
                <div class="d-flex justify-content-between">
                    <button type="button" v-can="'material_country/create'"
                        class="btn btn-primary mr-2" data-toggle="modal" data-target="#modal-form"
                        @click="resetModel(); formTitle = 'Tambah Negara'">
                        Tambah Negara
                    </button>
                </div>

            </template>

            <template v-slot:search>
                <div class="input-group form-search-rounded">
                    <input class="form-control py-2 border-right-0 border" v-model="search" type="search"
                        id="example-search-input" placeholder="Cari">
                    <span class="input-group-append">
                        <div class="input-group-text bg-transparent">
                            <span class="text-blue"><i class="fa fa-search"></i></span>
                        </div>
                    </span>
                </div>
            </template>

            <template v-slot:columnHeader>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Nama Negara</th>
                        <th>Code Negara</th>
                        <th width="10%">Aksi</th>
                    </tr>
                </thead>
            </template>

            <template v-slot:action="{ data }">
                <div class="btn-action-block">
                    <button type="button" v-can="'material_country/detail'"
                        class="btn btn-icon-small btn-success-trans waves-effect waves-light mr-2" data-toggle="modal"
                        data-target="#modal-detail" @click.prevent="editMode(data); formTitle = 'Detail Negara'">
                        <i class="fa fa-eye"></i>
                    </button>
                    <button type="button" v-can="'material_country/update'"
                        class="btn btn-icon-small btn-warning-trans waves-effect waves-light mr-2" data-toggle="modal"
                        data-target="#modal-form" @click.prevent="editMode(data); formTitle = 'Ubah Negara'">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button type="button" v-can="'material_country/delete'"
                        @click="destroy(data)" class="btn btn-icon-small btn-danger-trans waves-effect waves-light"
                        id="confirm-text" style="margin-left: 2px;">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </template>
        </List>

        <!-- Modal Form -->
        <ModalB4 :title="formTitle" id="modal-form">
            <Form ref="formCrud"
                @deleted="getList" 
                @saved="getList"
            />
        </ModalB4>

        <!-- Modal detail -->
        <ModalB4 title="Detail Negara" id="modal-detail">
            <Detail ref="formDetail"/>
            <template #footer>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Tutup</button>
                </div>
            </template>
        </ModalB4>

    </section>
</template>

<script>
import List from '@/components/List.vue'
import Form from './Form.vue'
import Detail from './Detail.vue'
import ModalB4 from '@/components/ModalB4.vue'

export default {
    name: 'NegaraIndex',
    components: {
        List, Form, Detail, ModalB4
    },
    data() {
        return {
            table: {
                title: "Negara Material",
                breadcumb: "Master Data",
                dataTable: {
                    lists: [],
                    columns: [ 'name', 'code']
                }
            },
            formTitle: 'Tambah Negara',
            search: null,
            detail: [],
            linkBukti: '',
            model: {
                name: '',
                code: '',
                id: null,
            },
            currentSort: 'id',
            currentSortDir: 'desc',
        }
    },
    mounted() {
        let _ = this
        _.getList()
        _.$root.$on("paginate", (data) => {
            _.getList(data)
        })
    },
    methods: {
        getList(page) {
            let _ = this
            _.axios.get('/material-countries', {
                params: {
                    search: _.search,
                    page: page,
                    sort: _.currentSortDir,
                    orderby: _.currentSort
                }
            })
            .then(resp => {
                _.table.dataTable.lists = resp.data.data
            })
            .catch(err => {
                if(err.response.status === 404) {
                    _.$toast.error('API belum tersedia')
                } else {
                    _.$toast.warning('terjadi kesalahan')
                }
            })
        },
        resetModel() {
            this.$refs.formCrud.resetModel()
        },
        editMode(item) {
            this.$refs.formCrud.editMode(item)
            this.$refs.formDetail.editMode(item)
        },
        destroy(item) {
            this.$refs.formCrud.destroy(item)
        },
        sortBy(x) {
            if (x === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSortDir = 'asc'
            }
            this.currentSort = x;
            this.getList()
        }
    },
    watch: {
        search: function () {
            this.getList()
        }
    }
}
</script>